exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.register-container[data-v-31aaca16]{width:980px;margin:24px auto;display:block;padding:48px 0\n}\n.register-container h4[data-v-31aaca16]{font-size:2.5rem;line-height:3.5rem;font-weight:bold;letter-spacing:.38px;color:#000;text-align:center;padding-top:2.5rem;padding-bottom:1.2rem\n}\n.register-container .subtitle[data-v-31aaca16]{padding-top:1.5rem;padding-bottom:1.75rem\n}\n.register-container p[data-v-31aaca16]{text-align:center;font-size:1.25rem;line-height:2rem\n}\n.register-container .fa-check[data-v-31aaca16]{color:#2e7d32;font-size:3rem;text-align:center;display:block\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31aaca16","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/register/RegisterOk.vue
// module id = /pvq
// module chunks = 1